module.exports = __webpack_public_path__ + "static/img/isw.75076c4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/isw.png
// module id = 53Fq
// module chunks = 1